import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import LogoWhite from '../../../assets/images/logo-white.svg'
import LogoWhiteAr from "../../../assets/images/Saudia TYS logo_colour.png";
import FaceBook from '../../../assets/images/icons/facebook.svg'
import Youtube from '../../../assets/images/icons/youtube.svg'
import Instagram from '../../../assets/images/icons/instagram.svg'
import X from '../../../assets/images/icons/x.svg'
import { handleApiCall } from '../../../apis'
import { endpoints } from '../../../utils/endpoints'
import { useLanguage } from "../../../context/LanguageContext";

function Footer() {
  const [soundTrackUrl, setSoundTrackUrl] = useState("");
  const [privacyContent, setPrivacyContent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { language } = useLanguage();

  const fetchSoundTrack = useCallback(async () => {
    try {
      const response = await handleApiCall("get", endpoints.getSoundTrackBookingTicket);
      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.success === true
      ) {
        const trackUrl = response?.data?.data?.soundTrack?.sound_track || "";
        setSoundTrackUrl(trackUrl);
      }
    } catch (error) {
      console.error("Error fetching sound track:", error);
    }
  }, []);

  const fetchContentByType = useCallback(async (type, setter) => {
    try {
      const response = await handleApiCall("get", `${endpoints.getContent}?type=${type}`);
      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.success === true
      ) {
        const data = response?.data?.data;
        let normalized = null;
        if (Array.isArray(data)) {
          normalized = data[0] || null;
        } else if (Array.isArray(data?.data)) {
          normalized = data.data[0] || null;
        } else {
          normalized = data || null;
        }
        setter(normalized);
      } else {
        setter(null);
      }
    } catch (error) {
      console.error(`Error fetching ${type} content:`, error);
      setter(null);
    }
  }, []);

  useEffect(() => {
    fetchSoundTrack();
    fetchContentByType("privacy_policy", setPrivacyContent);
  }, [fetchSoundTrack, fetchContentByType]);

  const handleSoundTrackClick = (e) => {
    e.preventDefault();
    if (soundTrackUrl) {
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handlePrivacyPolicyClick = (e) => {
    e.preventDefault();
    if (!privacyContent) return;

    // Prioritize language-specific URLs, then fall back to other known fields
    const languageSpecificUrls =
      language === "AR"
        ? [privacyContent?.description_ar, privacyContent?.description_arabic]
        : [privacyContent?.description_en, privacyContent?.description_english];

    const fallbackUrls = [privacyContent?.description];

    const possibleUrls = [...languageSpecificUrls, ...fallbackUrls].filter(Boolean);

    for (const url of possibleUrls) {
      const trimmedUrl = String(url).trim();
      if (/^https?:\/\//i.test(trimmedUrl)) {
        window.open(trimmedUrl, "_blank", "noopener,noreferrer");
        return;
      }
    }
  };

  const handleTermsConditionsClick = (e) => {
    e.preventDefault();
    const fullUrl = `${window.location.origin}/terms-and-conditions`;
    window.open(fullUrl, "_blank", "noopener,noreferrer");
  };

  //console.log("language", language);
  //console.log( "LogoWhite",LogoWhite);
  //console.log("LogoWhiteAr", LogoWhiteAr);
  return (
    <>
        <div className="bg-saudiaGreen footer">
            <div className='container max-w-8xl mx-auto px-6 md:px-8 lg:px-14 md:my-10'>
                {/* <div className='logo flex items-center justify-center md:inline-flex mt-8 md:mt-0'>
                    <img src={LogoWhite} alt="Logo"/>
                </div> */}
                <div className='logo flex items-center justify-center md:inline-flex mt-8 md:mt-0'>
                  <img
                    src={language === "AR" ? LogoWhiteAr : LogoWhite}
                    alt={language === "AR" ? "الشعار" : "Logo"}
                    className="h-12 w-auto object-contain brightness-0 invert"
                  />
                </div>
                <div className={`links [&_a]:text-[#F3EBDD] md:flex items-center justify-between mt-6 py-6 md:py-8 border-t md:border-y border-[#F3EBDD] text-lg font-ManMedium text-center ${language === "AR" ? "md:text-right" : "md:text-left"}`}>
                    <div className='flex flex-col gap-2'>
                        <Link to="#" onClick={handlePrivacyPolicyClick}>
                          {language === "AR" ? "سياسة الخصوصية" : "Privacy Policy"}
                        </Link>
                        {/* <Link to="#" onClick={handleTermsConditionsClick}>
                          {language === "AR"
                            ? "الشروط والأحكام (Terms & Conditions)"
                            : "Terms & Conditions"}
                        </Link> */}
                        <Link 
                          to="#"
                          onClick={handleSoundTrackClick}
                          className="cursor-pointer"
                        >
                          {/* Take Your Seat full soundtrack */}
                          {language === "AR" 
                            ? "احجز مقعدك الآن – المقطع الصوتي" 
                            : "Take Your Seat full soundtrack"}
                        </Link>
                    </div>
                    <div className='social flex gap-x-2.5 border-t md:border-none mt-8 pt-6 md:mt-0 md:pt-0 border-[#F3EBDD] justify-center md:justify-start'>
                        <a 
                            href="https://www.facebook.com/SaudiArabianAirlines" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                        >
                            <img src={FaceBook} alt="Facebook"/>
                        </a>
                        <a 
                            href="https://youtube.com/@saudia?si=4pKhYhCN2vImoFXM" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="Youtube"
                        >
                            <img src={Youtube} alt="Youtube"/>
                        </a>
                        <a 
                            href="https://www.instagram.com/saudi_airlines/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            <img src={Instagram} alt="Instagram"/>
                        </a>
                        <a 
                            href="https://x.com/SaudiAirlinesEN" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="X (Twitter)"
                        >
                            <img src={X} alt="X"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        {/* Sound Track Modal */}
        {showModal && (
          <div 
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
            onClick={handleCloseModal}
          >
            <div 
              className="bg-white rounded-lg p-8 max-w-md w-full mx-4"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-saudiaGreen">
                  {/* Take Your Seat Full Soundtrack */}
                  {language === "AR" 
                    ? "المقطع الصوتي الكامل لـ \"خذ مقعدك\"" 
                    : "Take Your Seat full soundtrack"
                  }
                </h3>
                <button
                  onClick={handleCloseModal}
                  className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                >
                  ×
                </button>
              </div>
              {soundTrackUrl ? (
                <audio 
                  controls 
                  autoPlay
                  className="w-full"
                  src={soundTrackUrl}
                >
                  Your browser does not support the audio element.
                </audio>
              ) : (
                <p className="text-gray-600">Sound track not available.</p>
              )}
            </div>
          </div>
        )}
    </>
  )
}

export default Footer
